import axios from 'axios';

export const API = axios.create({
    baseURL: `${window.location.protocol}//${window.location.host}`,
    headers: {'Content-Type': 'application/json'}
});